import { Component, CUSTOM_ELEMENTS_SCHEMA, forwardRef, inject, input, InputSignal } from '@angular/core';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RegisterUserFormService } from 'src/app/pages/register-user/services/register-user-form.service';
import { BaseFormField } from 'src/app/pages/register-user/shared/form/abstracts/base-form-field';

@Component({
  selector: 'app-time-field',
  standalone: true,
  imports: [
    TranslateModule, 
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: forwardRef(() => TimeFieldComponent),
    },
  ],
  templateUrl: './time-field.component.html',
  styleUrls: ['./time-field.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TimeFieldComponent extends BaseFormField<string | null> {
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string | null> = input<string | null>(null);
  
  private _registerUserFormService = inject(RegisterUserFormService);
  
  protected startTime = this._registerUserFormService.startTime;
  protected endTime = this._registerUserFormService.endTime;

  protected getCurrentValue(): string | null {
    return this.isStartTime()
      ? this._registerUserFormService.startTime() ? this._registerUserFormService.startTime() : ''
      : this._registerUserFormService.endTime() ? this._registerUserFormService.endTime() : '';
  }
  
  protected getLabel(): string {
    return this.isStartTime() ? 'Hora inicio de la ruta' : 'Hora fin de la ruta';
  }
  
  protected getMinTime(): string {
    if (this.isStartTime()) {
      return '09:00'; // min for startTime
    } else {
      return this.startTime() || '09:00';
    }
  }
  
  protected getMaxTime(): string {
    if (this.isStartTime()) {
      return this.endTime() || '23:00';
    } else {
      return '23:00'; // max for endTime
    }
  }
  
  protected isStartTime(): boolean {
    return this.formControlName() === 'startTime';
  }
  
  protected handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.value; // from BaseFormField
    this.onChange(target.value); // from BaseFormField
    
    console.log(`Input time value: ${target.value}`);
    
    if (this.isStartTime()) {
      this._registerUserFormService.setStartTime(target.value);
    } else {
      this._registerUserFormService.setEndTime(target.value);
    }
  }
}
